import { SVGProps } from 'react';

const TableOfContents = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 12H3m13 6H3M16 6H3m18 6h.01M21 18h.01M21 6h.01"
    />
  </svg>
);
export default TableOfContents;
